/**
 * Print tokens for the submission PDF, from the loan-application design spec.
 *
 * RGB triples because jsPDF's colour setters take channels, not hex.
 *
 * One saturated accent per surface: pine is the brand accent, blue is reserved
 * for STATUS, amber for URGENCY, gold for EQUITY. Red is document-tag
 * decoration only — a failing value uses amber, never red.
 */
const T = {
  ink: [16, 24, 40], // #101828
  slate: [102, 112, 133], // #667085
  line: [231, 234, 238], // #E7EAEE
  faint: [241, 243, 245], // #F1F3F5
  paper: [245, 246, 248], // #F5F6F8
  white: [255, 255, 255],

  // LENDMARQ DIVERGENCE: the document's brand accent is the app's primary blue
  // (`colors.blue[600]`, #1F5AF2 — the same one the public forms and the
  // dashboard chrome use), so a printed submission is recognisably from this
  // product. It's chrome only: the eyebrow and the document rule. Pine below
  // stays a DATA colour (economics bars, the approved chip), which is why the
  // two coexist rather than one replacing the other.
  brand: [31, 90, 242], // #1F5AF2
  brandTint: [234, 240, 254], // #EAF0FE

  pine: [20, 96, 63], // #14603F
  pineTint: [233, 244, 238], // #E9F4EE
  pineMuted: [136, 183, 158], // #88B79E — cost bars

  blue: [29, 78, 216], // #1D4ED8
  blueTint: [234, 240, 254], // #EAF0FE

  amber: [180, 83, 9], // #B45309
  gold: [201, 162, 39], // #C9A227

  red: [180, 35, 24], // #B42318
  redTint: [253, 236, 236], // #FDECEC

  track: [233, 236, 239], // bar track
  zebra: [250, 251, 252], // #FAFBFC table stripe
};

// Letter at 72dpi, ~0.58in margins. Everything on the page is measured off
// MARGIN and CONTENT_W, so this pair is the one place page padding is set —
// tightening it here widens every section, column and rule together.
export const PAGE = { w: 612, h: 792 };
export const MARGIN = 42;
export const CONTENT_W = PAGE.w - MARGIN * 2; // 528
export const COL_GUTTER = 28;
export const COL_W = (CONTENT_W - COL_GUTTER) / 2; // 250

/**
 * jsPDF ships only the 14 standard PDF fonts, so Inter and IBM Plex Mono aren't
 * available without embedding the TTFs. Helvetica and Courier are the standard
 * stand-ins and preserve what the spec is actually after: a sans face for prose
 * and labels, a monospaced face for every machine-ish value.
 */
export const FONT = { sans: "helvetica", mono: "courier" };

export default T;
